import React, { useState, useEffect } from "react";
import {useTranslation} from "react-i18next";

// Original prices for Black Friday comparison
const originalPrices = {
    Children: {
        oneMonth: [
            { entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 45 },
            { entries: "3 Hyrje në Javë - 12 Hyrje në Muaj", cost: 55 },
            { entries: "4 Hyrje në Javë - 16 Hyrje në Muaj", cost: 70 },
            { entries: "5 Hyrje në Javë - 20 Hyrje në Muaj", cost: 90 },
        ],
        threeMonths: [
            { entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 115 },
            { entries: "3 Hyrje në Javë - 12 Hyrje në Muaj", cost: 135 },
            { entries: "4 Hyrje në Javë - 16 Hyrje në Muaj", cost: 155 },
            { entries: "5 Hyrje në Javë - 20 Hyrje në Muaj", cost: 200 },
        ],
         sixMonths: [
     
                { entries: "3 Hyrje në Javë - 12 Hyrje në Muaj", cost: 270 },
            
            ],
    },
    Infants: {
        oneMonth: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 50 }],
        threeMonths: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 120 }],
    },
    Adults: {
        oneMonth: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 50 }],
        threeMonths: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 120 }],
    },
};

export const TeamDiscountCard = ({ formData, setFormData, discountData, ageGroup, ageStart, ageEnd }) => {
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const [dropDown, setDropDown] = useState(false);
    const [dropDown2, setDropDown2] = useState(false);
    const [dropDown3, setDropDown3] = useState(false);
    const [entries, setEntries] = useState(discountData?.oneMonth?.[0] || null);
    const [selectedMonth, setSelectedMonth] = useState(1);
    const [monthData, setMonthData] = useState(discountData?.oneMonth || []);
    const [gender, setGender] = useState("Femra(Avancuar)");

    // const discountedCost = Math.ceil(entries.cost * (1 - (entries.discount / 100)));

    const [plan, setPlan] = useState(false)

    const {t} = useTranslation()

    const handleChosePlan = () => {
        if (!entries) return;
        setFormData((prevData) => ({...prevData, time: selectedMonth}));
        setFormData((prevData) => ({...prevData, discount: entries.discount || 0,}));
        setFormData((prevData) => ({...prevData, totalAmount: entries.cost,}));   
        // setFormData((prevData) => ({...prevData, payableAmount: discountedCost}));   
        setFormData((prevData) => ({...prevData, payableAmount: entries.cost}));   
        setFormData((prevData) => ({...prevData, entries: entries.entries}));   
        setFormData((prevData) => ({...prevData, ageGroup: ageGroup}));   
        setFormData((prevData) => ({...prevData, gender: gender}));   
    }

    const isSelected = () => {
        if (!entries) return false;
        if (formData.time == selectedMonth && formData.discount == entries.discount && formData.totalAmount == entries.cost
            && formData.entries == entries.entries && formData.ageGroup == ageGroup)
        {
            return true;
        } else {
            return false;
        }
    }

    const [disabled , setDisabled] = useState(false)

    // Sync internal state with formData when it changes externally (e.g., from image click)
    useEffect(() => {
        if (formData.ageGroup === ageGroup && formData.time && formData.entries && discountData) {
            // Update selectedMonth based on formData.time
            if (formData.time === 1 && selectedMonth !== 1) {
                setSelectedMonth(1);
                setMonthData(discountData.oneMonth || []);
            } else if (formData.time === 2 && selectedMonth !== 2) {
                setSelectedMonth(2);
                setMonthData(discountData.twoMonths || []);
            } else if (formData.time === 3 && selectedMonth !== 3) {
                setSelectedMonth(3);
                setMonthData(discountData.threeMonths || []);
            } else if (formData.time === 6 && selectedMonth !== 6) {
                setSelectedMonth(6);
                setMonthData(discountData.sixMonths || []);
            } else if (formData.time === 12 && selectedMonth !== 12) {
                setSelectedMonth(12);
                setMonthData(discountData.twelveMonths || []);
            }
            
            // Update entries based on formData.entries
            const currentMonthData = formData.time === 1 ? (discountData.oneMonth || []) :
                                   formData.time === 2 ? (discountData.twoMonths || []) :
                                   formData.time === 3 ? (discountData.threeMonths || []) :
                                   formData.time === 6 ? (discountData.sixMonths || []) :
                                   formData.time === 12 ? (discountData.twelveMonths || []) : (discountData.oneMonth || []);
            
            const matchingEntry = currentMonthData?.find(entry => entry.entries === formData.entries);
            if (matchingEntry && (!entries || entries.entries !== matchingEntry.entries)) {
                setEntries(matchingEntry);
            }
        }
    }, [formData.time, formData.entries, formData.ageGroup, ageGroup, discountData, selectedMonth, entries]);

    // Completely removed overlay - no longer checking age
    // useEffect(() => {
    //     if (formData.age && formData.age > 0) {
    //         setDisabled(false)
    //     } else {
    //         setDisabled(true)
    //     }
    // }, [formData.age]);

    return (
        <div className="relative">
            <div className={`absolute inset-0 bg-white bg-opacity-50 z-10 ${disabled ? 'block' : 'hidden'} `}></div>
            <div className="flex flex-col gap-5 border-2 border-gray-200 rounded-2xl min-w-[320px] p-6 max-h-fit h-fit font-custom2 bg-white shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex flex-col gap-2 rounded-xl relative w-full">
                    <button
                        onClick={() => setDropDown(!dropDown)}
                        id="dropdownDefaultButton"
                        data-dropdown-toggle="dropdown"
                        className="text-blue-700 bg-blue-50 border border-blue-200 font-semibold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center justify-between w-full hover:bg-blue-100 transition-colors"
                        type="button"
                    >
                        {selectedMonth} {t('month')}
                        <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                        </svg>
                    </button>

                    <div id="dropdown" className={`z-10 bg-white text-black top-12 absolute divide-y divide-gray-100 rounded-lg shadow-lg border border-gray-200 w-full ${dropDown ? 'block' : 'hidden'}`}>
                        <ul className="py-2 text-sm" aria-labelledby="dropdownDefaultButton">
                            <li>
                                <a
                                    onClick={(e) => { 
                                        e.preventDefault();
                                        setSelectedMonth(1); 
                                        setMonthData(discountData?.oneMonth || []); 
                                        setEntries(discountData?.oneMonth?.[0] || null); 
                                        setDropDown(false); 
                                    }}
                                    href="#"
                                    className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                >
                                    1 {t('month')}
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={(e) => { 
                                        e.preventDefault();
                                        setSelectedMonth(3); 
                                        setMonthData(discountData?.threeMonths || []); 
                                        setEntries(discountData?.threeMonths?.[0] || null); 
                                        setDropDown(false); 
                                    }}
                                    href="#"
                                    className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                >
                                    3 {t('month')}
                                </a>
                            </li>
                                   <li>
                                <a
                                    onClick={(e) => { 
                                        e.preventDefault();
                                        setSelectedMonth(6); 
                                        setMonthData(discountData?.sixMonths || []); 
                                        setEntries(discountData?.sixMonths?.[0] || null); 
                                        setDropDown(false); 
                                    }}
                                    href="#"
                                    className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                >
                                    6 {t('month')}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="flex flex-col gap-2 rounded-xl relative w-full">
                    <button
                        onClick={() => setDropDown2(!dropDown2)}
                        id="dropdownDefaultButton"
                        data-dropdown-toggle="dropdown"
                        className="text-blue-700 bg-blue-50 border border-blue-200 font-semibold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center justify-between w-full hover:bg-blue-100 transition-colors"
                        type="button"
                    >
                        {entries?.entries || "Zgjidh hyrjet"}
                        <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                        </svg>
                    </button>

                    <div id="dropdown" className={`z-50 bg-white text-black top-12 absolute divide-y divide-gray-100 rounded-lg shadow-lg border border-gray-200 w-full ${dropDown2 ? 'block' : 'hidden'}`}>
                        <ul className="py-2 text-sm" aria-labelledby="dropdownDefaultButton">
                            {
                                monthData?.map((month, index) => (
                                    <li key={index}>
                                        <a
                                            onClick={(e) => { 
                                                e.preventDefault();
                                                setEntries(month); 
                                                setDropDown2(false); 
                                            }}
                                            href="#"
                                            className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                        >
                                            {month.entries}
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
                <div className={`flex-col gap-2 rounded-xl relative w-full ${ageStart > 17 ? 'flex' : 'hidden'}`}>
                    <button
                        onClick={() => setDropDown3(!dropDown3)}
                        id="dropdownDefaultButton"
                        data-dropdown-toggle="dropdown"
                        className="text-blue-700 bg-blue-50 border border-blue-200 font-semibold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center justify-between w-full hover:bg-blue-100 transition-colors"
                        type="button"
                    >
                        {gender || "Zgjidh gjininë"}
                        <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                        </svg>
                    </button>

                    <div id="dropdown" className={`z-10 bg-white text-black top-12 absolute divide-y divide-gray-100 rounded-lg shadow-lg border border-gray-200 w-full ${dropDown3 ? 'block' : 'hidden'}`}>
                            <ul className="py-2 text-sm" aria-labelledby="dropdownDefaultButton">
                                <li>
                                    <a
                                        onClick={(e) => { 
                                            e.preventDefault();
                                            setGender("Femra(Avancuar)"); 
                                            setDropDown3(false); 
                                        }}
                                        href="#"
                                        className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                    >
                                        Femra(Avancuar)
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={(e) => { 
                                            e.preventDefault();
                                            setGender("Meshkujt (Fillestar&Avancuar)"); 
                                            setDropDown3(false); 
                                        }}
                                        href="#"
                                        className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                    >
                                        Meshkujt (Fillestar&Avancuar)
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={(e) => { 
                                            e.preventDefault();
                                            setGender("Meshkuj & Femra (Fillestar)"); 
                                            setDropDown3(false); 
                                        }}
                                        href="#"
                                        className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                    >
                                        Meshkuj & Femra (Fillestar)
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                <div className="flex flex-col gap-4 pt-2">
                    {/* Display entries */}
                    {entries && (
                        <>
                            <div className="flex items-center gap-2">
                                <span className="text-gray-600 font-medium">Hyrjet:</span>
                                <span className="text-gray-800 font-semibold text-lg">{entries.entries}</span>
                            </div>
                            
                            {/* Price display with discount */}
                            {(() => {
                                const currentCost = entries.cost;
                        const originalData = originalPrices[ageGroup === "children" ? "Children" : ageGroup === "infants" ? "Infants" : "Adults"];
                        let originalMonthData;
                        if (selectedMonth === 1) {
                            originalMonthData = originalData.oneMonth;
                        } else if (selectedMonth === 3) {
                            originalMonthData = originalData.threeMonths;
                        } else if (selectedMonth === 6) {
                            originalMonthData = originalData.sixMonths;
                        } else if (selectedMonth === 12) {
                            originalMonthData = originalData.twelveMonths;
                        } else {
                            originalMonthData = originalData.oneMonth;
                        }
                        const originalEntry = originalMonthData?.find(o => o.entries === entries.entries);
                        const originalCost = originalEntry?.cost || currentCost;
                        
                        const discount = originalCost > currentCost && currentCost > 0
                            ? Math.round(((originalCost - currentCost) / originalCost) * 100)
                            : 0;
                        
                        return (
                            <div className="flex flex-col gap-2 bg-gray-50 rounded-lg p-4 border border-gray-200">
                                {discount > 0 && (
                                    <div className="flex items-center justify-between mb-2">
                                        <span className="text-gray-500 text-sm line-through">Çmimi i vjetër</span>
                                        <div className="flex items-center gap-2">
                                            <span className="text-gray-500 text-sm line-through font-medium">{originalCost}€</span>
                                            <span className="bg-red-600 text-white px-2.5 py-1 rounded-full text-xs font-bold shadow-md">
                                                -{discount}%
                                            </span>
                                        </div>
                                    </div>
                                )}
                                <div className="flex items-center justify-between">
                                    <span className="text-gray-700 font-semibold">Çmimi</span>
                                    <span className="text-black-600 font-bold text-2xl">{currentCost}€</span>
                                </div>
                            </div>
                        );
                    })()}
                        </>
                    )}
                   {/* <span
  style={{
    display: "inline-block",

    fontSize: "18px",
    fontWeight: "bold",
    color: "black",
    textTransform: "uppercase", // Uppercase for emphasis
    padding: "5px 10px",
    borderRadius: "6px",
    textAlign: "center",
    letterSpacing: "1px",
    backgroundClip: "text",
   
    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.2)",
  }}
>
  <b style={{ color: "black", fontSize: "14px" }}>Ofertat për FUNDVIT -</b>
  <b style={{ color: "blue", fontSize: "16px" }}>
    Zbritje deri në 20%
  </b>
</span>  */}
                    <button 
                        onClick={() => {setPlan(!plan); handleChosePlan()}} 
                        className={`w-full border-2 font-bold rounded-lg py-3 px-4 transition-all duration-300 ${
                            isSelected() 
                                ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700 shadow-md' 
                                : 'bg-white text-blue-600 border-blue-600 hover:bg-blue-50 hover:shadow-md'
                        }`}
                    >
                        {isSelected() ? t('unChoosePlan') : t('choosePlan')}
                    </button>
                </div>
            </div>
        </div>
    );
};
